module.exports = __webpack_public_path__ + "static/img/sprite.48c19f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/Default/sprite.png
// module id = 1645
// module chunks = 28